import type { PageLayoutMetrics } from 'features/knowledgeDocumentViewer/components/viewer/continuous/pageLayoutMetrics'
import { useMemo } from 'react'

type LoadedRange = {
  start: number
  end: number
}

export function useVirtualPageWindow(
  loadedRange: LoadedRange,
  totalPages: number,
  pageGap: number,
  pageLayoutMetrics: PageLayoutMetrics
) {
  return useMemo(() => {
    const start = Math.max(1, loadedRange.start)
    const end = Math.min(totalPages, loadedRange.end)
    const pages = Array.from(
      { length: Math.max(0, end - start + 1) },
      (_, index) => start + index
    )

    // PageListWrapper's flex gap supplies the gap adjacent to each spacer.
    const topSpacerHeight =
      start <= 1
        ? 0
        : Math.max(0, (pageLayoutMetrics.tops[start - 1] ?? 0) - pageGap)

    const lastPageTop = pageLayoutMetrics.tops[end - 1] ?? 0
    const lastPageHeight = pageLayoutMetrics.heights[end - 1] ?? 0
    const renderedBottom = lastPageTop + lastPageHeight
    const bottomSpacerHeight =
      end >= totalPages
        ? 0
        : Math.max(0, pageLayoutMetrics.totalHeight - renderedBottom - pageGap)

    return { bottomSpacerHeight, pages, topSpacerHeight }
  }, [loadedRange, pageGap, pageLayoutMetrics, totalPages])
}
